export type LoginEventBucket = "active" | "past";

/** Active = published + live profile + not ended. Everything else is past (unpublished / inactive / ended). */
export const loginEventBucket = (
  event: { published: boolean; endDate: Date | null },
  profileActive: boolean,
  now: Date = new Date()
): LoginEventBucket => {
  const ended = event.endDate != null && event.endDate.getTime() <= now.getTime();
  if (event.published && profileActive && !ended) return "active";
  return "past";
};
